module.exports = __webpack_public_path__ + "static/media/elsa-jean-win.cbe548bb.jpg";